import {section} from './content';
import {StyledBrandImage, StyledFeaturedInSection, StyledImageContainer} from './styles';

const FeaturedInSection = () => {
  return (
    <StyledFeaturedInSection $verticalPadding="m">
      <h2 className="sr-only">{section.title}</h2>

      <StyledImageContainer>
        {section.images.map((image) => (
          <li key={image.id}>
            <StyledBrandImage
              $id={image.id}
              src={image.src}
              alt={image.alt}
              width={image.width}
              height={image.height}
              unoptimized
            />
          </li>
        ))}
      </StyledImageContainer>
    </StyledFeaturedInSection>
  );
};

export default FeaturedInSection;
